<template>
  <div class="task-page">
    <van-nav-bar title="啟動" />

    <div class="item">
      <ul class="task-grid">
        <li v-for="(v, key) in displayGameItem" :key="key" @click="toLottery(v.key, v.id)">
          <div class="task-logo">
            <img class="animate__animated animate__flipInX" alt="" :src="v.ico">
          </div>
          <p class="task-name">{{ v.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameitem: [],
    };
  },
  computed: {
    displayGameItem() {
      return this.gameitem.slice(0, 4);
    },
  },
  methods: {
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/Lottery?key=' + key + '&id=' + id });
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_hot',
      }).then((res) => {
        this.gameitem = res.data || [];
      });
    },
  },
  created() {
    this.getGameItem();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/basenew.css";
.van-nav-bar {
  z-index: 999;
  position: relative;
  background: url(/img/header.svg) no-repeat 50%/100%;
}

.van-nav-bar::v-deep .van-nav-bar__content {
  height: 54px;
}

.van-nav-bar::v-deep .van-nav-bar__title {
  color: #fff;
  font-size: 36px;
  font-weight: 500;
  line-height: 64px;
}

.task-page {
  min-height: 100%;
  background: #f3f3f5;
  padding-top: 0;
}

.task-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 26px 20px;
  padding: 18px 22px 20px;
}

.task-grid li {
  background: #fff;
  border: 2px solid #b89acc;
  border-radius: 18px;
  padding: 18px 10px 16px;
  text-align: center;
}

.task-logo {
  width: 144px;
  height: 144px;
  margin: 0 auto 12px;
  border-radius: 18px;
  overflow: hidden;
  background: #f5f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.task-name {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  color: #2b1d46;
}
</style>
